import { setToken as _setToken, setOpenId as _setOpenId } from "@/functions";

export const updateAnalysis = (state, data = {}) => {
  Object.assign(state.analysis, data)
}
// TODO: 应改为 Action
export const setToken = (state, token) => {
  state.token = token;
  _setToken(token);
};

// TODO: 应改为 Action
export const setOpenId = (state, value) => {
  state.openId = value;
  _setOpenId(value);
};

export const setAccessToken = (state, value) => {
  state.accessToken = value;
};

export const setUserFromWX = (state, target) => {
  state.userFromWX = target;
};

export const setUserFromJava = (state, target) => {
  state.userFromJava = target;
};

export const setShopCar = (state, list) => {
  state.shopCar = list;
};

export const setHomeBanners = (state, list) => {
  state.homeBanners = list;
};

export const setHomeHeadingNews = (state, list) => {
  state.homeHeadingNews = list;
};

export const setHomeGoods = (state, list) => {
  state.homeGoods = list;
};

export const setHomeMarkets = (state, list) => {
  state.homeMarkets = list;
};
